var userAgent = require('../internals/engine-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-webos-webkit.js
// module id = 1081
// module chunks = 0